import React from 'react';
import { Line } from 'react-konva';

const leftTri = 4;
const rightTri = 8;
const centerTri = 6;
const heightTri = 3;
const strokeWidthAdd = .05;

export const Triangletip = ({
   left,
   top,
   onMouseEnter,
   onMouseLeave,
   strokeWidth,
   bubbleBodyHeight,
   bubbleBodyWidth,
   yCoord4Bubble,
   leftBubble,
  }) => {

  top += yCoord4Bubble + bubbleBodyHeight + .1;

  left += leftBubble;

  return <Line
    x={left}
    y={top}
    points={[
          leftTri, 0,
          rightTri, 0,
          centerTri, heightTri]}
    fill={'white'}
    stroke={'gray'}
    strokeWidth={strokeWidth + strokeWidthAdd}
    closed={true}
    lineCap = {'block'}
    perfectDrawEnabled={false}
    listening={false}
  />;
};

export const Trianglehide = ({ // a blank white strip across top of triangle so the pointer looks like part of the bubble
   left,
   top,
   onMouseEnter,
   onMouseLeave,
   strokeWidth,
   bubbleBodyHeight,
   bubbleBodyWidth,
   yCoord4Bubble,
   leftBubble
  }) => {

  top += yCoord4Bubble + bubbleBodyHeight - .5;

  left += leftBubble;

  return <Line
    x={left}
    y={top}
    points={[
          leftTri, 0,
          rightTri, 0,
          centerTri, heightTri]}
    fill={'white'}
    stroke={'white'}
    strokeWidth={strokeWidth + strokeWidthAdd}
    closed={true}
    lineCap = {'block'}
    perfectDrawEnabled={false}
    listening={false}
  />;
};
